import NodeCache from 'node-cache';

let cache = null;

if (process.server) {
  cache = new NodeCache({ stdTTL: 600 });
}

/**
 * Server-side cache: node-cache (Nuxt SSR only).
 * Use this in Nuxt apps - client always runs fetcher (no cache).
 *
 * @param {string|Array} queryKey - Cache identity, e.g. ['productSchema', locale] (TanStack Query style)
 * @param {Function} fetcher - Async or sync function that returns the value to cache
 * @param {Object} options - Optional config
 * @param {number} options.ttl - TTL in seconds (default: 10min)
 * @returns {Promise<any>} Cached or freshly fetched value
 */
// eslint-disable-next-line import/prefer-default-export
export function serverRemember(queryKey, fetcher, options = {}) {
  if (!process.server || !cache) {
    return Promise.resolve(fetcher());
  }

  const { ttl = 10 * 60 } = options;

  const normalizedKey = Array.isArray(queryKey) ? queryKey : [queryKey];
  const cacheKey = `cache_${JSON.stringify(normalizedKey)}`;

  const cached = cache.get(cacheKey);
  if (cached !== undefined) return Promise.resolve(cached);

  return Promise.resolve(fetcher()).then((value) => {
    cache.set(cacheKey, value, ttl);
    return value;
  });
}
